import { render, staticRenderFns } from "./smsBtn.vue?vue&type=template&id=657be279&scoped=true&"
import script from "./smsBtn.vue?vue&type=script&lang=js&"
export * from "./smsBtn.vue?vue&type=script&lang=js&"
import style0 from "./smsBtn.vue?vue&type=style&index=0&id=657be279&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657be279",
  null
  
)

export default component.exports